import React, { Component } from "react";
import "./tnc.css";

export default class TermsNConditions extends Component {
  render() {
    return (
      <div className="m-5">
        <h2 className="text-center">XTRAPOWER TOOLS BUMPER OFFER CONTEST</h2>
        <h3 className="text-center">TERMS AND CONDITIONS</h3>
        <p>
          By participating in the <strong>XTRAPOWER TOOLS BUMPER</strong> offer
          contest, you agree to abide by the following Terms and Conditions set
          forth by <strong>LSL TOOLS PVT. LTD</strong>. The contest is conducted
          through authorized dealers and retailers. By completing your
          registration, you confirm that you have read, understood, and
          irrevocably accepted these Terms and Conditions, in their latest
          version, as well as all applicable laws and regulations, without any
          restrictions or qualifications.
        </p>

        <p>
          <strong>Contest Period</strong>
        </p>
        <p>The bumper offer contest timeline will be as per tabled below.</p>
        <div style={{ overflowX: "auto" }}>
          <table>
            <tbody>
              <tr>
                <td>
                  <p>
                    <strong>S. No.</strong>
                  </p>
                </td>
                <td>
                  <p>
                    <strong>Particulars</strong>
                  </p>
                </td>
                <td>
                  <p>
                    <strong>Quarterly basis</strong>
                  </p>
                </td>
                <td>
                  <p>
                    <strong>Year Basis</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>1</p>
                </td>
                <td>
                  <p>Prize</p>
                </td>
                <td>
                  <p>
                    4 Refrigerators (175 Litres) and 4 Televisions (32-inch) to
                    be awarded per quarter, respectively.
                  </p>
                </td>
                <td>
                  <p>CAR*</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>2</p>
                </td>
                <td>
                  <p>Contest Period</p>
                </td>
                <td>
                  <p>From April 2026 to March 2027 (Quarter-wise Basis)</p>
                </td>
                <td>
                  <p>01st April 2026 – 31st March 2027</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>3</p>
                </td>
                <td>
                  <p>Cut-off Time</p>
                </td>
                <td>
                  <p>Up to 11:59 PM on the last date of each quarter</p>
                </td>
                <td>
                  <p>Up to 11:59 PM on 31 March 2027</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>4</p>
                </td>
                <td>
                  <p>Verification of Entries</p>
                </td>
                <td colSpan="2">
                  <p>Within 10 days from the cut-off date</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>5</p>
                </td>
                <td>
                  <p>Lucky Draw</p>
                </td>
                <td colSpan="2">
                  <p>
                    Within 10 days after completion of the verification process
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>6</p>
                </td>
                <td>
                  <p>Result Declaration</p>
                </td>
                <td colSpan="2">
                  <p>Within 30 days from the closing date of the contest</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>7</p>
                </td>
                <td>
                  <p>Prize Distribution</p>
                </td>
                <td colSpan="2">
                  <p>Within 30 days after completion of winner formalities</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <p>
          <strong>
            Note: In case of any changes the information will be updated on our
            Mobile App/Website (
            <a
              href="https://www.xtrapowertools.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.xtrapowertools.com
            </a>
            )
          </strong>
        </p>

        <p>
          <strong>Result</strong>
        </p>
        <p>
          The results will be announced through WhatsApp/Call on the registered
          mobile number and will also be published on the official website and
          social media handles of LSL TOOLS PVT. LTD.
        </p>
        <br />
        <p>
          <strong>Eligibility Criteria</strong>
        </p>
        <p>
          In order for you to be eligible for XTRAPOWER TOOLS bumper offer
          contest you must satisfy the following criteria:
        </p>
        <p>
          You must purchase any XTRAPOWER Power Tools from any of the authorized
          retail outlets, running this offer all over India.
        </p>
        <ul>
          <li>
            You should be above 18 (eighteen) years of age; (The minimum age of
            participant shall be 18 years)
          </li>
          <li>You must be a citizen of India.</li>
          <li>This Contest is valid only in India.</li>
          <li>State of Tamil Nadu is excluded from this contest; *(Note 3)</li>
          <li>
            You must not have any criminal record nor should be of an unsound
            mind; and you must not be an employee of LSL TOOLS PVT. LTD. and its
            group companies, its affiliate or associate companies, or the
            relative of any such employee. You must not be a dealer, retailer or
            a relative of the same.
          </li>
        </ul>
        <p>
          You agree that your failure to comply with the Terms and Conditions as
          set-out hereinunder and any other formalities stipulated by LSL TOOLS
          PVT. LTD. during the Contest Period shall disqualify you from
          participating in XTRAPOWER TOOLS bumper offer contest.
        </p>
        <br />
        <p>
          <strong>Conditions for Participation</strong>
        </p>
        <p>
          To participate in the XTRAPOWER TOOLS Bumper Offer contest, you must
          purchase XTRAPOWER TOOLS product from a retail outlet during the
          Contest Period. A GST invoice signed and stamped copy of the bill
          along with signed and stamped warranty card is mandatory. After your
          purchase, register through the XTRAPOWER TOOLS mobile application,
          available for download on the App Store or Google Play Store (for iOS
          and Android devices). To complete registration, you should scan and
          authenticate the sticker found on the product's box. After scanning,
          scratch the sticker to reveal a code, which must be entered into the
          designated field on the app. Once the code is entered, verified, and
          the product is registered for warranty, you will be automatically
          entered into the Bumper Offer.
        </p>
        <br />
        <p>
          <strong>Process of Selection of Winners</strong>
        </p>
        <p>
          Winners of the XTRAPOWER TOOLS Bumper Offer contest will be selected
          by virtue of a fair and transparent random draw process, which may be
          conducted in the presence of independent observers or auditors to
          ensure transparency and compliance with applicable laws.
        </p>
        <p>
          LSL TOOLS PVT. LTD. will announce the winners and following the
          announcement, we will notify the winners via WhatsApp or Call on their
          registered contact numbers, requesting confirmation to claim their
          prize. To confirm eligibility, winners must provide a copy of a valid
          government-issued ID (such as a Voter ID, Aadhar Card, or Driving
          License). Upon receiving the confirmation and ID verification, we will
          arrange for the delivery of the prize within 30 days.
        </p>
        <p>
          If a winner fails to respond to our WhatsApp/Call within 15 working
          days, is found ineligible, or does not comply with the Terms and
          Conditions, they will forfeit their prize. In such cases, the prize
          will be offered to the next eligible participant, selected through a
          new draw. Our responsibility is limited to informing the winners via
          Call, WhatsApp, SMS, and our social media platforms, and we are not
          obliged to follow up further. If a winner does not receive
          communication regarding their prize, it is their responsibility to
          contact us using the details provided on our website.
        </p>
        <p>
          Participants acknowledge that merely entering the{" "}
          <strong>XTRAPOWER TOOLS</strong> Bumper Offer contest does not
          guarantee a prize. Only those officially announced as winners by{" "}
          <strong>LSL TOOLS PVT. LTD</strong>. are eligible to claim the prizes.
        </p>
        <p>
          Winners' names will be posted on our website (www.xtrapowertools.com)
          and social media platforms, including WhatsApp, Instagram, Facebook,
          LinkedIn.
        </p>
        <p>
          The decision of the Company regarding eligibility, verification, and
          determination of winners shall be final and binding.
        </p>
        <br />
        <p>
          <strong>Prize Details</strong>
        </p>
        <p>
          The participants who emerge as winners based on the lucky draw
          selection in <strong>XTRAPOWER TOOLS BUMPER OFFER</strong> contest
          will be entitled in the following manner to claim the following prize:
        </p>
        <p>
          Upon completion of each quarter during the Financial Year 2026–2027, a
          total of eight (8) lucky winners shall be selected under the Scheme,
          comprising four (4) winners of Refrigerators (175 Liter) and four (4)
          winners of Televisions (32 Inch). Each eligible winner shall be
          entitled to receive only one prize. Upon completion of the Financial
          Year 2026–2027, one (1) lucky winner shall be selected for the Annual
          Prize, being a Car, subject to the terms and conditions of the Scheme.
        </p>
        <p>
          The brand, make, model, colour and specifications of all prizes,
          including the Refrigerators, Televisions and Car, shall be determined
          solely by LSL TOOLS PRIVATE LIMITED at its discretion and shall be
          subject to availability. No participant shall have any right to claim
          any particular brand, model, variant, colour or specification of any
          prize.
        </p>
        <p>
          LSL TOOLS PRIVATE LIMITED reserves the right, at its sole discretion,
          to increase the number of prizes, introduce additional prizes, or
          substitute any prize with another prize of equivalent or higher value
          in the event of non-availability or circumstances beyond its
          reasonable control. Any such substitution or modification shall not
          materially diminish the value of the prize offered under the Scheme.
        </p>
        <p>
          The decision of LSL TOOLS PRIVATE LIMITED regarding eligibility,
          verification of entries, selection of winners and distribution of
          prizes shall be final and binding on all participants, and no
          correspondence or dispute in this regard shall be entertained.
        </p>
        <p>
          The winner(s) of the above prize(s) cannot assign or transfer or
          exchange their respective prize(s).
        </p>
        <br />
        <p>
          <strong>Prize Collection</strong>
        </p>
        <p>
          The winners of the Refrigerator and Television prizes shall collect
          their respective prizes from the nearest authorized LSL TOOLS PRIVATE
          LIMITED dealer, distributor, or designated collection centre, as may
          be notified by the Company. The winners shall be required to produce
          valid identity proof and such other documents as may be requested by
          the Company for verification purposes prior to receiving the prize.
        </p>
        <p>
          Any costs, expenses or arrangements incurred in connection with the
          collection of the prize from the designated location shall be borne
          solely by the winner, unless otherwise specified by the Company.
        </p>
        <br />
        <p>
          <strong>Limitations of Liability and Release</strong>
        </p>
        <p>
          By participating in the XTRAPOWER TOOLS Bumper Offer Contest, you
          agree to release LSL TOOLS PVT. LTD. from any claims, damages, or
          liabilities arising from or related to your participation. You also
          waive any rights to seek punitive, incidental, consequential, or other
          forms of damages.
        </p>
        <p>
          Please note that LSL TOOLS PVT. LTD. is not responsible for the
          quality of prizes, as these items are not manufactured by us. We are
          not liable for any defects or damages associated with the awarded
          goods.
        </p>
        <p>
          Winners are solely responsible for any applicable taxes, including
          income tax, gift tax, or other statutory tax liabilities that may
          arise in connection with the prize(s), as per current regulations. LSL
          TOOLS PVT. LTD. will deduct tax at source (TDS) as per the provisions
          of the Income Tax Act, 1961, wherever applicable, and issue the
          necessary certificate to the winner.
        </p>
        <p>
          LSL TOOLS PVT. LTD. assumes no responsibility for any technical issues
          or malfunctions that may affect the operation of the XTRAPOWER TOOLS
          Bumper Offer Contest.
        </p>
        <ul>
          <li>Hardware or software errors.</li>
          <li>
            Faulty computer, cable, satellite, network, electronic, Internet
            connectivity or other online or network communication problems;
          </li>
          <li>
            Errors or limitations of any internet service providers, servers,
            hosts, or other providers;
          </li>
          <li>Garbled, jumbled, or faulty data transmissions;</li>
          <li>Lost, late, delayed, or intercepted transmissions;</li>
          <li>
            Unauthorized human or non-human intervention of the operation of
            XTRAPOWER TOOLS lucky draw contest, including without limitation,
            unauthorized tampering, hacking, theft, virus, bugs, or worms; or
          </li>
          <li>
            Destruction of any aspect of XTRAPOWER TOOLS bumper offer contest,
            or loss, miscount, misdirection, inaccessibility, or unavailability
            of the contact number used in connection with XTRAPOWER TOOLS bumper
            offer contest.
          </li>
        </ul>
        <br />
        <p>
          <strong>Our Rights</strong>
        </p>
        <p>
          LSL TOOLS PVT. LTD.'s decisions regarding all matters related to the
          XTRAPOWER TOOLS Bumper Offer Contest will be final and binding on all
          participants. We reserve the right to extend, discontinue, or make
          changes to the contest at any time, including but not limited to
          modifications of the eligibility criteria, participation process,
          selection procedures, and contest duration. Such changes may be
          implemented at our sole discretion due to business requirements or in
          response to statutory or regulatory updates, and all participants will
          be bound by these revisions.
        </p>
        <p>
          The winners, or their legal heirs, will have no further claims or
          rights against LSL TOOLS PVT. LTD. beyond the prizes they are awarded.
        </p>
        <br />
        <p>
          <strong>Data Privacy</strong>
        </p>
        <p>
          By participating in this contest, you consent to the collection,
          storage, and use of your personal information (including but not
          limited to name, contact details, and photographs) by LSL TOOLS PVT.
          LTD. for the purposes of administering the contest, announcing
          winners, and for marketing and promotional activities. Your data will
          be handled in accordance with the Privacy Policy available on our
          mobile application and website, and in compliance with applicable data
          protection laws in India.
        </p>
        <br />
        <p>
          <strong>No Purchase Necessary</strong>
        </p>
        <p>
          Participation in this contest is subject to purchase of XTRAPOWER
          Power Tools as specified above. No alternate method of entry is
          available.
        </p>
        <br />
        <p>
          <strong>Product Source &amp; Authentication Clause</strong>
        </p>
        <p>
          Participation in the Contest is valid only for products purchased
          through the Company's authorized dealer network. Purchases made from
          unauthorized sellers or third-party online platforms may not be
          eligible for participation.
        </p>
        <p>
          The Company shall not be responsible for any issues arising due to
          acts or omissions of such unauthorized sellers, including cases where
          the product's hologram sticker, or authentication code is found to be
          tampered with, damaged, illegible, or already registered prior to
          purchase.
        </p>
        <p>
          In such cases, the purchaser may approach the respective
          seller/platform for resolution. The Company may assist in
          verification; however, participation in the Contest shall be subject
          to successful validation of a genuine and unused authentication code.
        </p>
        <p>
          Non-participation due to invalid or previously used authentication
          credentials, or purchase from unauthorized channels, shall not entitle
          the purchaser to any prize or compensation from the Company, except
          where such defect is directly attributable to the Company's authorized
          supply chain.
        </p>
        <p>
          Nothing contained herein shall limit the rights available to consumers
          under applicable law.
        </p>
        <br />
        <p>
          <strong>Disqualification</strong>
        </p>
        <p>
          LSL TOOLS PVT. LTD. reserves the right to disqualify any participant
          found to be tampering with the entry process or the operation of the
          contest, or to be acting in violation of these Terms and Conditions or
          in an unsportsmanlike or disruptive manner.
        </p>
        <br />
        <p>
          <strong>Limitation Period for Claims</strong>
        </p>
        <p>
          Any claim or dispute arising out of or in connection with this contest
          must be raised within 30 days from the date of announcement of
          results, failing which the participant shall be deemed to have waived
          all rights in respect thereof.
        </p>
        <br />
        <p>
          <strong>Force Majeure</strong>
        </p>
        <p>
          XTRAPOWER TOOLS bumper offer contest is subject to any force majeure
          circumstances i.e. any event directly or indirectly resulting from any
          acts of God including but not limited to fire, flood, earthquake, or
          other natural disasters, an act of any sovereign including but not
          limited to war, rebellion, military or usurped power or confiscation,
          destruction or damage to property, riots, terrorist attacks,
          lockdowns, and lockouts by or under the order of any government or
          imposition of government law, judgment, order or decree, sanction,
          embargo or similar action, blockade, or labour dispute, epidemic,
          pandemics, accidents, strikes, explosions, or other similar or
          different contingencies which are beyond the control of LSL TOOLS PVT.
          LTD. which cannot reasonably be forecasted or provided against, and
          cannot be predicted by men of ordinary prudence. In case of any such
          force majeure conditions, no liability in whatsoever manner can be
          attributed to LSL TOOLS PVT. LTD.
        </p>
        <br />
        <p>
          <strong>Deemed Acceptance of Terms</strong>
        </p>
        <p>
          By purchasing the product and/or registering for participation in the
          Contest, the participant shall be deemed to have read, understood, and
          accepted these Terms and Conditions in full. It shall be the
          responsibility of the participant to review the applicable Terms and
          Conditions, as made available on the Company's official platforms,
          prior to participation.
        </p>
        <br />
        <p>
          <strong>Modification / Withdrawal Clause</strong>
        </p>
        <p>
          The Company reserves the right to modify, suspend, or withdraw the
          Contest in case of any unforeseen circumstances, force majeure events,
          or regulatory requirements, provided that such changes shall not
          adversely affect participants who have already complied with the
          eligibility conditions prior to such modification or withdrawal.
        </p>
        <p>
          Any material changes to the Contest shall be communicated through the
          Company's official platforms within a reasonable time.
        </p>
        <br />
        <p>
          <strong>Governing Law and Jurisdiction</strong>
        </p>
        <p>
          These Terms and Conditions shall be governed by and interpreted in
          accordance with the laws of India. Any disputes arising from these
          Terms and Conditions will be subject to the exclusive jurisdiction of
          the courts in Gurugram, Haryana.
        </p>

        <p>
          <strong>NOTE 1:</strong>{" "}
          <strong>
            "CONTEST PARTICIPATION VALID ONLY ON PURCHASE FROM AUTHORIZED
            DEALERS. VERIFY INTACT HOLOGRAM STICKER BEFORE PURCHASE".
          </strong>
        </p>
        <p>
          <strong>NOTE 2:</strong>{" "}
          <strong>
            "YOU CONFIRM AND ACKNOWLEDGE THAT YOU ARE AWARE THAT BY
            PARTICIPATING IN THIS CONTEST, YOU HAVE GIVEN US RIGHTS TO USE YOUR
            NAME, PHOTOGRAPH AND OTHER PERSONAL DETAILS FOR THE PURPOSE OF THIS
            CONTEST".
          </strong>
        </p>
        <p>
          <strong>NOTE 3:</strong>{" "}
          <strong>
            "THE RESIDENTS OF THE STATE OF TAMIL NADU ARE NOT ELIGIBLE TO
            PARTICIPATE IN XTRAPOWER TOOLS LUCKY BUMPER OFFER CONTEST IN
            COMPLIANCE WITH THE PROVISIONS OF THE TAMIL NADU PRIZE SCHEME
            (PROHIBITION) ACT, 1979."
          </strong>
        </p>
      </div>
    );
  }
}
